import * as React from 'react';
import {
	DashboardMenuItem, Menu, MenuItemLink, useResourceDefinitions, useSidebarState,
} from 'react-admin';
import ViewList from '@mui/icons-material/ViewList';
import {
	WithAnyRolesPermissions,
} from '../DataProviderExtension/authExtension';

export default (props) => {
	const resources = useResourceDefinitions();
	const [open] = useSidebarState();
	const { hasDashboard, onMenuClick } = props;
	return (
		<Menu {...props}>
			{hasDashboard ? <DashboardMenuItem /> : null}
			{Object.keys(resources).map((name) => (
				resources[name]?.options?.show !== false
					? (
						<MenuItemLink
							key={name}
							to={`/${name}`}
							primaryText={
								(resources[name].options && resources[name].options.label)
								|| name
							}
							leftIcon={
								resources[name].icon ? resources[name].icon : <ViewList />
							}
							onClick={onMenuClick}
							sidebarIsOpen={open}
						/>
					)
					: null
			))}
			<WithAnyRolesPermissions
				roles={['master', 'tradeUnionAdmin']}
			>
				<MenuItemLink
					key="verificationCode"
					to="verificationCode"
					primaryText="Код проверки"
					leftIcon={<ViewList />}
					onClick={onMenuClick}
					sidebarIsOpen={open}
				/>
				<MenuItemLink
					key="printableBusiness"
					to="printableBusiness"
					primaryText="Печать списка партнеров"
					leftIcon={<ViewList />}
					onClick={onMenuClick}
					sidebarIsOpen={open}
				/>
			</WithAnyRolesPermissions>
		</Menu>
	);
};
